export const FETCH_INFO_INTERVENTO = "FETCH_INFO_INTERVENTO@surgery";
export const FETCH_INFO_INTERVENTO_SUCCESS = "FETCH_INFO_INTERVENTO_SUCCESS@surgery";
export const RESET_INFO_INTERVENTO = "RESET_INFO_INTERVENTO@surgery";
export const START_POLLING = "START_POLLING@surgery";
export const STOP_POLLING = "STOP_POLLING@surgery";
export const UPDATE_TIME_INFO = "UPDATE_TIME_INFO@surgery";
export const INCREMENT_CALL_NUMBER = "INCREMENT_CALL_NUMBER@surgery";
export const RESET_FETCH_INFO_INTERVENTO_ENDED = "RESET_FETCH_INFO_INTERVENTO_ENDED@surgery";
export const SALVA_INFO_STRUTTURA = "SALVA_INFO_STRUTTURA@surgery";
export const SET_RICERCA_EFFETTUATA = "SET_RICERCA_EFFETTUATA@surgery";
